import get from 'lodash/get';
export const isStandaloneApp = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && (window.matchMedia('(display-mode: standalone)').matches || get(window, 'navigator.standalone') === true);
export default isStandaloneApp;

//# sourceMappingURL=isStandaloneApp.js.map